import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import CheckBoxResultField from "@components/Calculator/CheckBoxResultField/checkBoxResultField.component";
import ResultField from "@components/Calculator/ResultField/resultField.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

import {
    CorrugatedSheetShoppingList,
    OndulineProductTileModel,
} from "../corrugatedSheetCalculator.types";

type CorrugatedSheetShoppingListComponentProps = {
    result: CorrugatedSheetShoppingList;
    toggleAcc: (acc: OndulineProductTileModel) => void;
    activeAcc: Array<OndulineProductTileModel>;
};

const CorrugatedSheetShoppingListComponent = ({
    result,
    toggleAcc,
    activeAcc,
}: CorrugatedSheetShoppingListComponentProps) => {
    const { t } = useGranite();
    const { fixture, sheet, accessories } = result;

    if (!fixture || !sheet) {
        return null;
    }

    return (
        <div id="shopping-list">
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={sheet.title}
                    copyPostfix={t(
                        "calculator.corrugatedSheetCalculator.numberOfSheets.note",
                    )}
                    value={sheet.amount.toFixed(0)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={fixture.title}
                    value={fixture.amount.toFixed(0)}
                />
            </Row>
            <Row>
                <Col>
                    <h3>
                        {t(
                            "calculator.corrugatedSheetCalculator.accessoiries.title",
                        )}
                    </h3>
                    <p>
                        {t(
                            "calculator.corrugatedSheetCalculator.accessoiries.description",
                        )}
                    </p>
                </Col>
            </Row>
            {accessories?.map(acc => (
                <Row key={acc.sku}>
                    <CheckBoxResultField
                        sm={12}
                        md={8}
                        lg={6}
                        copy={acc.title}
                        value={acc.amount.toFixed(0)}
                        onCheck={() => toggleAcc(acc)}
                        isChecked={activeAcc.some(a => a.sku === acc.sku)}
                        sku={acc.sku}
                    />
                </Row>
            ))}
        </div>
    );
};

export { CorrugatedSheetShoppingListComponent };
